import { render } from "./NavBarMMS.vue?vue&type=template&id=52796c0e&scoped=true"
import script from "./NavBarMMS.vue?vue&type=script&lang=js"
export * from "./NavBarMMS.vue?vue&type=script&lang=js"

import "./NavBarMMS.vue?vue&type=style&index=0&id=52796c0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52796c0e"]])

export default __exports__